import { StyleSheet, Text } from '@react-pdf/renderer'
import BreakText from 'src/features/reports/result/downloadPDF/BreakText'

const styles = StyleSheet.create({
  title: {
    paddingLeft: 5,
  },
})

type HeaderProps = {
  questionName: string
  labelInspectionResultName?: string
}

export const Header = ({
  questionName,
  labelInspectionResultName,
}: HeaderProps) => {
  return (
    <>
      <BreakText text={questionName} />
      {labelInspectionResultName && (
        <Text style={styles.title}>{labelInspectionResultName}</Text>
      )}
    </>
  )
}
